import * as SalesOrder from '@/services/rest-api/lib/sales-order/sales-order'

export function tabelFilterFields(instance) {
  return [
    {
      name: 'created_on',
      label: instance.$t('salesOrder.field.createdDate'),
      type: 'date-picker',
      datepickerType: 'datetime',
      valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
      format: 'DD MMM YYYY HH:mm',
      titleFormat: 'DD MMM YYYY',
      rangeSeparator: ' - ',
      range: true,
      confirm: true,
      confirmText: instance.$t('global.apply'),
      disabledDate: (date) => {
        return date > new Date()
      },
      shortcuts: [
        {
          text: instance.$t('global.time.today'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setHours(0, 0, 0)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
        {
          text: instance.$t('global.time.yesterday'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setDate(startDate.getDate() - 1)
            startDate.setHours(0, 0, 0)

            endDate.setDate(endDate.getDate() - 1)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
        {
          text: instance.$t('global.time.last3Days'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setDate(startDate.getDate() - 3)
            startDate.setHours(0, 0, 0)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
        {
          text: instance.$t('global.time.last7Days'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setDate(startDate.getDate() - 7)
            startDate.setHours(0, 0, 0)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
      ],
    },
    {
      name: 'customer_name',
      label: instance.$t('salesOrder.field.customer'),
      type: 'value-help-v2',
      placeholder: instance.$t('salesOrder.placeholder.customer'),
      trackBy: 'value',
      displayedBy: 'value',
      listGetter: async (filter) => {
        const res = await SalesOrder.getSuggestions('customer-name')

        let filteredRes
        if (filter?.search) {
          filteredRes = res.data.suggestions.filter((data) => {
            return data.value.includes(filter.search)
          })
        } else {
          filteredRes = res.data.suggestions
        }

        return {
          data: {
            paginated_result: filteredRes
          },
          metadata: {
            count: filteredRes.length,
            page: 1,
            total_page: 1,
            total_count: filteredRes.length,
          }
        }
      },
      multiple: true,
      tableFields: [
        {
          label: instance.$t('salesOrder.field.customerName'),
          key: 'value',
          isSortable: true,
        },
      ],
    },
    {
      type: 'range-input',
      label: instance.$t('salesOrder.field.totalWeight'),
      min: {
        name: 'total_weight_min',
        label: instance.$t('salesOrder.field.minimal'),
        type: 'text',
        _type: 'number',
        validation: 'bail|number|min:0,value',
        suffix: 'Kg',
        'validation-behavior': 'live',
        mask: Number,
      },
      max: {
        name: 'total_weight_max',
        label: instance.$t('salesOrder.field.maximal'),
        type: 'text',
        _type: 'number',
        validation: 'bail|number|min:0,value',
        suffix: 'Kg',
        'validation-behavior': 'live',
        mask: Number,
      },
    },
    {
      type: 'range-input',
      label: instance.$t('salesOrder.field.totalVolume'),
      min: {
        name: 'total_volume_min',
        label: instance.$t('salesOrder.field.minimal'),
        type: 'text',
        _type: 'number',
        validation: 'bail|number|min:0,value',
        suffix: 'Cbm',
        'validation-behavior': 'live',
        mask: Number,
      },
      max: {
        name: 'total_volume_max',
        label: instance.$t('salesOrder.field.maximal'),
        type: 'text',
        _type: 'number',
        validation: 'bail|number|min:0,value',
        suffix: 'Cbm',
        'validation-behavior': 'live',
        mask: Number,
      },
    },
    {
      type: 'range-input',
      label: instance.$t('salesOrder.field.totalPrice'),
      min: {
        name: 'total_price_min',
        label: instance.$t('salesOrder.field.minimal'),
        type: 'text',
        _type: 'number',
        validation: 'bail|number|min:0,value',
        prefix: 'Rp',
        'validation-behavior': 'live',
        mask: Number,
      },
      max: {
        name: 'total_price_max',
        label: instance.$t('salesOrder.field.maximal'),
        type: 'text',
        _type: 'number',
        validation: 'bail|number|min:0,value',
        prefix: 'Rp',
        'validation-behavior': 'live',
        mask: Number,
      },
    },
  ]
}
